import { SxProps, Theme } from '@mui/material/styles';

export const scrollContainerSX: SxProps<Theme> = {
	overflowX: 'auto',
	scrollbarWidth: '0px',
	'&:not(:hover)::-webkit-scrollbar': {
		height: '8px',
		background: 'transparent',
	},
	'&:not(:hover)::-webkit-scrollbar-track': {
		background: 'transparent',
	},
	'&:not(:hover)::-webkit-scrollbar-thumb': {
		backgroundColor: 'transparent',
	},
	'&:hover::-webkit-scrollbar': {
		height: '8px',
	},
	'&:hover::-webkit-scrollbar-track': {
		background: '#EDEDED',
	},
	'&:hover::-webkit-scrollbar-thumb': {
		backgroundColor: '#5D5D5D',
		borderRadius: '10px',
		border: '2px solid transparent',
	},
	'&:hover::-webkit-scrollbar-thumb:hover': {
		backgroundColor: '#555',
	},
	'&::-webkit-scrollbar-button': {
		display: 'none',
	},
	pb: { xs: 'var(--spacing-5)', sm: 'var(--spacing-8)' },
	mb: { xs: 'var(--spacing-5)', sm: 'var(--spacing-8)' },
};
